import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=593f9ebe&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('593f9ebe')) {
      api.createRecord('593f9ebe', component.options)
    } else {
      api.reload('593f9ebe', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=593f9ebe&", function () {
      api.rerender('593f9ebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-84M1dJx5PSa0X/JS/videoIframe.vue"
export default component.exports